import { rolePermissions } from '@/permissions'

export function hasPermission(role, permission) {
  return rolePermissions[role]?.includes(permission)
}